module.exports = __webpack_public_path__ + "static/media/ev_app_logo.156f914a.png";